import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, auth, ...restProps }) => {
  if (!isLoaded(auth)) {
    return null;
  }

  const renderRoute = (props) => {
    if (!isEmpty(auth)) {
      return <Component {...props} />;
    }

    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    );
  };

  renderRoute.propTypes = {
    location: PropTypes.string.isRequired,
  };

  return <Route {...restProps} render={renderRoute} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default compose(
  firebaseConnect(),
  connect(({ firebase: { auth } }) => ({
    auth,
  })),
)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/router/ProtectedRoute.js